import { render } from "./LogoMark.vue?vue&type=template&id=34f885f6"
import script from "./LogoMark.vue?vue&type=script&lang=js"
export * from "./LogoMark.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__